import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(with-layout)/community/inquiry/new/page.tsx");
